module.exports = __webpack_public_path__ + "img/icon-common-settings.0e02b78.svg";